import React, { useCallback, useMemo } from 'react';
import BaseComponent from 'src/components/BaseComponent';
import { lang, permissions } from 'src/helpers';
import { DoctorInfoPanel, PatientInfoPanel } from 'src/components/complex';
import model from './model';
import filesModel from './filesModel';
import { MCText, ToggleSwitch } from 'components/basic';
import LANG_CONST from 'src/helpers/lang/const';

export const FreeChatForContact = ({ contactUser, user, template }) => {
  const loading = React.useRef(false);

  const active = useMemo(() => {
    const freeChatEnabled = user.freeChatEnabled || {};
    const freeForDoctors = freeChatEnabled?.doctors !== false;
    const freeForClinics = freeChatEnabled?.clinics !== false;

    if (contactUser.isClinic)
      return (
        (freeChatEnabled[contactUser.id] === undefined && freeForClinics) ||
        freeChatEnabled[contactUser.id] === true
      );
    if (contactUser.isDoctor)
      return (
        (freeChatEnabled[contactUser.id] === undefined && freeForDoctors) ||
        freeChatEnabled[contactUser.id] === true
      );

    return freeChatEnabled[contactUser.id] === true;
  }, [contactUser, user.freeChatEnabled]);

  const onClick = useCallback(() => {
    {
      if (loading.current) return;
      loading.current = true;

      model.handleFreeChatEnabled(contactUser.id, !active, () => {
        loading.current = false;
      });
    }
  }, [contactUser.id, active]);

  if (template === 'profile') {
    return (
      <div className={'mc-flex'}>
        <MCText
          label={LANG_CONST.free_messages}
          weight={400}
          textLight
          size={16}
          onClick={onClick}
          flex
        />
        <ToggleSwitch onChange={onClick} checked={active} />
      </div>
    );
  }
  return (
    <li>
      <div className={'mc-p15 mc-pointer mc-flex-20'}>
        <MCText label={LANG_CONST.free_messages} weight={500} size={20} onClick={onClick} />
        <ToggleSwitch onChange={onClick} checked={active} />
      </div>
    </li>
  );
};

class ProfilePopup extends BaseComponent {
  state = {};

  componentDidMount() {
    console.log('ProfilePopup mounted');
  }

  viewProfile = (subpage) => {
    const { PAGES } = permissions;
    let contactUser = model.state.contactUser;
    let url = PAGES.DOCTORS_DETAIL_PAGE.match(contactUser?.username);
    if (contactUser.isDoctor) {
      model.emit('openDoctor', contactUser);
      if (subpage && !model.state.user?.isDoctor) url += '/' + subpage;
    } else {
      url = PAGES.PATIENTS_DETAIL_PAGE.match(contactUser?.id);
    }
    this.navigate(url);
  };

  render() {
    const { contactUser } = model.state;
    return (
      <div className={'mc-popup-contain'} style={{ width: '50%', height: '50%' }}>
        <div className='mc-modal-header'>
          <div className='mc-popup-title'>{lang.t('profile')}</div>
          {this.props.closeBtn}
        </div>
        <div>
          {contactUser &&
            (contactUser.isDoctor ? (
              <DoctorInfoPanel
                {...contactUser}
                doctor={contactUser}
                closeBtn={() => model.setState({ hideInfo: true })}
                viewProfile={this.viewProfile.bind(this, '')}
                freeChatEl={
                  <FreeChatForContact
                    contactUser={contactUser}
                    user={model.state.user}
                    template={'profile'}
                  />
                }
              />
            ) : (
              <PatientInfoPanel
                patient={{ ...contactUser?.partnerProfile, id: contactUser.id }}
                viewProfile={this.viewProfile.bind(this, '')}
                closeBtn={() => model.setState({ hideInfo: true })}
                model={filesModel}
                freeChatEl={
                  <FreeChatForContact
                    contactUser={contactUser}
                    user={model.state.user}
                    template={'profile'}
                  />
                }
              />
            ))}
        </div>
      </div>
    );
  }
}

export default ProfilePopup;
